<list-edit
  *ngIf="mode === 'edit'"
  [value]="listItems"
  [headerTitle]="directoryTitle"
  [maxTitleLength]="maxTitleLength"
  (cancel)="onCancelEdit()"
  (return)="return.emit()"
  (save)="onSave($event)"
></list-edit>

<list-view
  *ngIf="mode === 'view'"
  [listItems]="listItems"
  [isParent]="isParent"
  [headerTitle]="directoryTitle"
  (edit)="onEdit()"
  (selectDirectory)="selectDirectory.emit($event)"
  (removeItem)="removeItem.emit($event)"
  (return)="return.emit()"
></list-view>
